export default __webpack_public_path__ + "static/media/14-DuneWalk.5acfe887.jpeg";